import type { RoomList } from '../components/RoomSelector/RoomSelector.types';
import { getRoomLists } from 'owa-calendar-scheduling-service/lib/services/placesService';
import { getRoomListsVNext } from 'owa-calendar-scheduling-service/lib/services/placesVNextService';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import type { PlacesResponse, RoomListResponse } from 'owa-location-service';

export default function getRoomListsFromPlacesApi(city?: string): Promise<RoomList[]> {
    if (isFeatureEnabled('cal-mf-usePlacesVNext')) {
        return getRoomListsVNext(city).then((roomListsResult: RoomListResponse) => {
            //Notice that Places VNext json response has all property names camel cased.
            if (roomListsResult?.value) {
                return roomListsResult.value.map(result => ({
                    name: result.displayName,
                    email: result.emailAddress,
                    key: result.emailAddress,
                }));
            }
            return [];
        });
    } else {
        return getRoomLists(city).then(response => {
            if (!isSuccessStatusCode(response.status)) {
                return Promise.resolve([]);
            }
            return response.json().then((roomListsResult: PlacesResponse) => {
                if (roomListsResult?.value) {
                    return roomListsResult.value.map(result => ({
                        name: result.Name,
                        email: result.EmailAddress,
                        key: result.EmailAddress,
                    }));
                }
                return [];
            });
        });
    }
}
